import { ServerFile } from '@/models/serverRequests/ServerFile'
import { travelDateLocalized } from '@/utils/travels'

export class FileData {
  constructor ({ files = [], last_update = 0 } = {}) {
    this.files = files.map(item => new ServerFile(item))
    this.lastUpdate = new Date(last_update * 1000)
  }

  get isLastUpdateAvailable () {
    return this.lastUpdate.getTime() !== 0
  }

  get formattedUpdateTimestamp () {
    return travelDateLocalized(this.lastUpdate)
  }
}
